'use client';
import styled from 'styled-components';
// eslint-disable-next-line import/no-unresolved
import { Swiper } from 'swiper/react';

import { Layout as DefaultLayout } from '@components/formStyles';

export const Layout = styled(DefaultLayout)`
  width: 100%;
  min-height: 500px;
`;

export const ContainerItem = styled.div<{ marginTop?: number }>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ marginTop = 0 }) => marginTop + 'px'};
`;

export const RulesInformationContainer = styled.div`
  & > div:first-child {
    max-width: initial;
    & > div:nth-child(2) > div:nth-child(2) {
      max-width: initial;
    }
  }
`;

export const ContentContainer = styled.div`
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 0 15px;
  }
`;
export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column-reverse;
  }
`;

export const CampaignPromotionsWrapper = styled.div`
  .header {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: normal;
    color: ${({ theme }) => theme.palette.darkGrey};
  }
`;

export const Banner = styled.div<{ url?: string }>`
  background-image: url(${({ url }) =>
    url || '/static/images/luxury-outdoor-swimming-pool-hotel-resort.png'});

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  height: 396px;
  position: relative;
  width: 100%;
  border-radius: 8px;
`;

export const Element = styled.div`
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.6);
`;

export const Title = styled.h1`
  font-size: 36px;
  font-weight: bold;
  position: relative;
  margin-left: 15px;
  color: ${({ theme }) => theme.palette.white};
  &:before {
    content: '';
    position: absolute;
    width: 6px;
    height: 27px;
    left: -15px;
    top: 16px;
    border-radius: 3px;
    background-color: ${({ theme }) => theme.palette.coral};
  }
`;

export const MapContent = styled.div`
  max-width: 360px;
  margin: 30px auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    margin: 0 auto;
  }
`;

export const CityMapWrapper = styled.div`
  width: 100%;
  height: 254px;
  border-radius: 5px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 203px;
  }
`;

export const CityMapLabel = styled.span`
  display: block;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-left: 10px;
  color: ${({ theme }) => theme.palette.darkGrey};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 18px;
  }
`;

export const OnlineOperationsContainer = styled.div`
  width: 100%;
  height: 186px;
`;
export const OnlineOperationsContainerTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;
export const OnlineOperationsItemContainer = styled.div`
  width: 100%;
  display: flex;
  height: 166px;
  gap: 20px;
`;
export const OnlineOperationsItem = styled.div<{ noMargin?: boolean }>`
  flex: 1;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 16px;
  border-radius: 8px;
  margin-left: ${({ noMargin }) => (noMargin ? '0' : 'auto')};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 320px;
  }
  @media only screen and (max-width: 1000px) {
    margin-left: 5px;
  }
  @media only screen and (max-width: 992px) {
    width: 100%;
    max-width: unset;
  }
`;
export const OnlineOperationsDescription = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  height: 72px;
  color: ${({ theme }) => theme.palette.darkGrey};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.SMALL})`} {
    height: 96px;
  }
`;
export const OnlineOperationsButtonContainer = styled.div`
  height: 56px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-top: 6px;
  display: grid;
  grid-template-columns: 90% 10%;
  padding: 16px;
  border-radius: 8px;
  cursor: pointer;
`;
export const ButtonNameContainer = styled.div`
  display: table;
  margin-top: -16px;
  height: 56px;
`;
export const OnlineOperationsButtonName = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  display: table-cell;
  vertical-align: middle;
  color: ${({ theme }) => theme.palette.darkGrey};
`;
export const StyledSwiper = styled(Swiper)`
  .swiper-slide {
    height: 186px;
  }
`;
export const ResponsiveTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  position: relative;
  color: ${({ theme }) => theme.palette.black};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.white};
`;
